// import BackgroundImage from "gatsby-background-image"
// import { FluidObject } from "gatsby-image"
import React from "react"
import styled from "styled-components"

import { MEDIUM_SCREEN_MEDIA_QUERY } from "../helpers/responsive_helpers"


interface ContentContainerProps {
  backgroundColor?: string
  overlayColor: string
}

const ContentContainer = styled.div<ContentContainerProps>`
  align-items: center;
  background: ${ ( props: ContentContainerProps ) => props.overlayColor };
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  padding: 0 5%;
  position: absolute;
  top: 0;
  right: 0;

  @media ${ MEDIUM_SCREEN_MEDIA_QUERY } {
    align-items: flex-start;
    background: ${ ( props: ContentContainerProps ) => props.backgroundColor };
    padding: 0 10% 0 100px;
    position: static;
    width: 50%;
  }
`

const ContentImageContainer = styled.div`
  display: flex;
  min-height: 420px;
  position: relative;
`

interface ImgContainerProps {
  image: string
}

const ImgContainer = styled.div<ImgContainerProps>`
  background: url( ${ ( props: ImgContainerProps ) => props.image } );
  height: 100%;
  min-height: 420px;
  width: 100%;

  @media ${ MEDIUM_SCREEN_MEDIA_QUERY } {
    width: 50%;
  }
`

const Title = styled.h2.attrs( {
  className: "ContentImageOverlay_Title"
} )`
  color: white;
  font-size: 2.25rem;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;

  @media ${ MEDIUM_SCREEN_MEDIA_QUERY }{
    text-align: left;
  }
`

const SubTitle = styled.h4.attrs( {
  className: "ContentImageOverlay_SubTitle"
} )`
  color: white;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 40px;
  position: relative;
  text-align: center;

  @media ${ MEDIUM_SCREEN_MEDIA_QUERY }{
    text-align: left;
  }
`

const CTALink = styled.a.attrs( {
  className: "ContentImageOverlay_CTALink"
} )`
  border: white 2px solid;
  border-radius: 6px;
  color: white;
  font-size: 0.875rem;
  font-weight: 700;
  padding: 1em 4.5em;
  text-align: center;
  text-transform: uppercase;
  width: 100;

  @media ${ MEDIUM_SCREEN_MEDIA_QUERY }{
    width: auto;
  }
`

interface ContentImageOverlayProps {
  backgroundColor: string
  ctaText: string
  ctaURL: string
  image: string
  overlayColor: string
  title: string
  subTitle: string
}

export const ContentImageOverlay = ( { backgroundColor, ctaText, ctaURL, image, overlayColor, title, subTitle }: ContentImageOverlayProps ) => (
  <ContentImageContainer>
    <ImgContainer image={ image } />
    <ContentContainer overlayColor={ overlayColor } backgroundColor={ backgroundColor }>
      <Title>{ title }</Title>
      <SubTitle>{ subTitle }</SubTitle>
      <CTALink href={ ctaURL }>{ ctaText }</CTALink>
    </ContentContainer>
  </ContentImageContainer>
)
